<div *ngIf="formGroup" [formGroup]="formGroup">
  <div *ngIf="isDaagmaatA else daagmaat">
    <label class="form-label"><b>Vak 1:</b></label>
    <div class="input-group">
      <input type="number" min="0" class="form-control form-control-sm" aria-describedby="maata" formControlName="maatA"
        (change)="onMaatAChanged()" integerOnly/>
      <span class="input-group-text">mm</span>
    </div>
    <luv-validationError [show]="showError('maatA')" [errorMessage]="errorMessage('maatA')">
    </luv-validationError>
    <!-- <br>
    <label for="Verstek" class="form-label">Verstek:</label>
    <input class="form-control" type="text" id="Verstek" placeholder="Geen" aria-label=".form-control-sm example"> -->
  </div>

  <ng-template #daagmaat>
    <div *ngIf="neutModel.position === NeutPosition.Right">
      <label class="form-label"><b>Vak {{ index + 2 }}:</b></label>
      <div class="input-group">
        <input type="number" min="0" class="form-control" aria-describedby="maatz" formControlName="maatZ"
          (change)="onMaatZChanged()" integerOnly/>
        <span class="input-group-text">mm</span>
      </div>
      <luv-validationError [show]="showError('maatZ')" [errorMessage]="errorMessage('maatZ')">
      </luv-validationError>
      <!-- <br>
      <label for="Verstek" class="form-label">Verstek:</label>
      <input class="form-control" type="text" id="Verstek" placeholder="Geen" aria-label=".form-control-sm example"> -->
    </div>

    <div *ngIf="neutModel.position !== NeutPosition.Right">
      <ng-container *ngIf="dorpelType !== 'Hefschuifdorpel'" class="col-lg-auto">
        <label class="form-label"><b>Vak {{ index + 2 }} Dagmaat:</b></label>
        <div class="input-group">
          <input type="number" min="0" class="form-control" aria-describedby="daagmaata1" formControlName="daagmaat"
            (change)="onDaagmaatChanged(index)" integerOnly/>
          <span class="input-group-text">mm</span>
        </div>
        <luv-validationError [show]="showError('daagmaat')" [errorMessage]="errorMessage('daagmaat')">
        </luv-validationError>

        <div *ngIf="isUitvoeringAvailable">
          <label class="form-label"><b>Uitvoering:</b></label>
          <select class="form-select" id="Sponningsoort" formControlName="sponningsoort"
            (change)="onSponningsoortChanged(index)">
            <option value="" disabled selected hidden>Kies</option>
            <option>Sponning</option>
            <option>Kader</option>
          </select>
          <luv-validationError [show]="showError('sponningsoort')" [errorMessage]="errorMessage('sponningsoort')">
          </luv-validationError>
        </div>

        <div *ngIf="this.isConversionDaagmaat()">
          <label class="form-label" (mouseenter)="showSponningmaatTooltip($event.target)"
            (mouseleave)="hideSponningmaatTooltip()" data-tooltip-type="sponningmaat"><b>Sponningdiepte:</b></label>
          <select class="form-select" id="Sponningmaat" formControlName="sponningmaat"
            (change)="onSponningmaatChanged(index)">
            <option *ngFor="let so of sponningmaatOptions" value="{{ so.value }}">{{ so.value }}mm</option>
          </select>
        </div>

        <div *ngIf="this.isConversionDaagmaat()">
          <label class="form-label"><b>Beglazingsprofiel:</b></label>
          <select class="form-select" id="Beglazingsprofiel" formControlName="beglazingsprofiel"
            (change)="onBeglazingsprofielChanged(index)">
            <option value="" selected>geen</option>
            <ng-container *ngFor="let glaslat of glaslatten">
              <option *ngIf="glaslat.typeAccessoire === 'Beglazingsprofiel'" [value]="glaslat.code">
                {{glaslat.omschrijving
                || glaslat.code}}</option>
            </ng-container>
          </select>
          <luv-validationError [show]="!!beglazingConflictError" [errorMessage]="beglazingConflictError">
          </luv-validationError>
        </div>


        <div *ngIf="this.isConversionDaagmaat() || this.isDKWisselvlak()">
          <label class="form-label"><b>Aanslagprofiel:</b></label>
          <select class="form-select" id="Aanslagprofiel" formControlName="aanslagprofiel"
            (change)="onAanslagprofielChanged(index)">
            <option value="" selected>geen</option>
            <ng-container *ngFor="let glaslat of glaslatten">
              <option *ngIf="glaslat.typeAccessoire === 'Aanslagprofiel'" [value]="glaslat.code">{{glaslat.omschrijving
                || glaslat.code}}</option>
            </ng-container>
          </select>
          <luv-validationError [show]="!!aanslagConflictError" [errorMessage]="aanslagConflictError">
          </luv-validationError>
        </div>

        <div *ngIf="this.isConversionDaagmaat() || this.isDKWisselvlak()" id="GemonteerdWrapper">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="gemonteerd" id="Gemonteerd">
              <label class="form-check-label" for="Gemonteerd" id="GemonteerdLabel">
                Gemonteerd
              </label>
            </div>
        </div>

        <div *ngIf="!this.isDKWisselvlak()">
          <label class="form-label"><b>Glaslat:</b></label>
          <select class="form-select" id="Glaslat" (change)="onGlaslatChanged(index)"
            formControlName="glaslat">
            <option value="" selected>geen</option>
            <ng-container *ngFor="let glaslat of glaslatten">
              <option *ngIf="glaslat.typeAccessoire === 'Glaslat'" [value]="glaslat.code">{{glaslat.omschrijving
                || glaslat.code}}</option>
            </ng-container>
          </select>
          <luv-validationError [show]="!!glaslatConflictError" [errorMessage]="glaslatConflictError">
          </luv-validationError>
        </div>

        <div *ngIf="this.isConversionDaagmaat() || this.isDKWisselvlak()">
          <label class="form-label"><b>Damverbreding:</b></label>
          <select class="form-select" id="Damverbreding" formControlName="damverbreeding"
            (change)="onDamverbreedingChanged(index)">
            <option value="0" selected>geen</option>
            <option value="5">5mm</option>
            <option value="10">10mm</option>
            <option value="15">15mm</option>
            <option value="20">20mm</option>
          </select>
        </div>

        <div *ngIf="this.isConversionDaagmaat()" id="DubbelAanslagprofielWrapper">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="dubbelAanslagprofiel" id="DubbelAanslagprofiel">
            <label class="form-check-label" for="DubbelAanslagprofiel" id="DubbelAanslagprofielLabel">
              Dubbel aanslagprofiel
            </label>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
</div>
<br>